// LENIS + SCROLLBAR
class ScrollBar extends HTMLElement {
  constructor() {
    super();

    this.lenis = null;
    this.hideScrollbarTimeout = null;

    this.initLenis();
    this.initScrollbar();
  }

  connectedCallback() {
    this.lenis.on('scroll', () => this.showScrollbarTemporarily());
    this.setupResizeHandler();
    this.setupAnchorLinks();
  }

  initLenis() {
    this.lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      smooth: true,
    });

    const raf = (time) => {
      this.lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }

  showScrollbarTemporarily() {
    document.documentElement.classList.add('show-scrollbar');
    clearTimeout(this.hideScrollbarTimeout);
    this.hideScrollbarTimeout = setTimeout(() => {
      document.documentElement.classList.remove('show-scrollbar');
    }, 100);
  }

  initScrollbar() {
    let start = null;

    const inner = this.querySelector('.inner');
    const thumb = this.querySelector('.thumb');

    let innerHeight = inner.offsetHeight;
    let thumbHeight = thumb.offsetHeight;

    const mapRange = (value, inMin, inMax, outMin, outMax) => {
      return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
    };

    const updateThumbPosition = (scroll, limit) => {
      const progress = scroll / limit;
      const maxThumbMove = innerHeight - thumbHeight;
      thumb.style.transform = `translate3d(0, ${progress * maxThumbMove}px, 0)`;
    };

    const updateDimensions = () => {
      innerHeight = inner.offsetHeight;
      thumbHeight = thumb.offsetHeight;
    };

    window.addEventListener('resize', updateDimensions);

    const onPointerMove = (e) => {
      if (!start) return;
      e.preventDefault();
      const thumbY = e.clientY - start;
      const maxThumbMove = innerHeight - thumbHeight;
      const clampedThumbY = Math.max(0, Math.min(thumbY, maxThumbMove));
      const scroll = mapRange(
        clampedThumbY,
        0,
        maxThumbMove,
        0,
        this.lenis.limit
      );
      this.lenis.scrollTo(scroll, { immediate: true });
    };

    const onPointerDown = (e) => {
      start = e.clientY - thumb.getBoundingClientRect().top;
      thumb.classList.add('grabbing');
    };

    const onPointerUp = () => {
      start = null;
      thumb.classList.remove('grabbing');
    };

    thumb.addEventListener('pointerdown', onPointerDown);
    window.addEventListener('pointermove', onPointerMove);
    window.addEventListener('pointerup', onPointerUp);

    this.lenis.on('scroll', ({ scroll, limit }) => {
      updateThumbPosition(scroll, limit);
    });
  }

  setupResizeHandler() {
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (typeof this.lenis.update === 'function') {
          this.lenis.update();
        }
      }, 150);
    });
  }

  setupAnchorLinks() {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    anchorLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          this.lenis.scrollTo(targetElement);
        }
      });
    });
  }
}
customElements.define('scroll-bar', ScrollBar);

// TRANSITION
// class PageTransition extends HTMLElement {
//   constructor() {
//     super();
//     this.isTransitioning = false;
//     this.pageContainer = null;
//     this.activeDate = null;
//   }

//   connectedCallback() {
//     this.style.cssText = `
//       position: fixed;
//       top: 0;
//       left: 0;
//       width: 100%;
//       height: 100%;
//       background-color: #9EB5C2;
//       z-index: 9999;
//       transform: translateY(100%);
//       transition: transform 1.2s cubic-bezier(0.76, 0, 0.24, 1);
//       pointer-events: none;
//       overflow: hidden;
//     `;

//     if (document.readyState === 'loading') {
//       document.addEventListener('DOMContentLoaded', () => this.init());
//     } else {
//       this.init();
//     }
//   }

//   init() {
//     this.pageContainer = document.getElementById('PageContainer');
//     if (!this.pageContainer) {
//       console.error('PageContainer not found');
//       return;
//     }
//     this.setupLinks();
//     window.addEventListener('pageshow', this.endPageTransition.bind(this));

//     const activeDateAttr = this.getAttribute('data-active-date');
//     if (activeDateAttr) {
//       this.activeDate = new Date(activeDateAttr);
//     }
//   }

//   isTransitionAllowed(link) {
//     if (link.getAttribute('transition') === 'false') {
//       return false;
//     }

//     if (link.hash) {
//       return false;
//     }

//     if (this.activeDate) {
//       const now = new Date();
//       return now >= this.activeDate;
//     }

//     return true;
//   }

//   startPageTransition() {
//     if (this.isTransitioning) return;
//     this.isTransitioning = true;

//     this.pageContainer.style.transition = 'transform 1.2s cubic-bezier(0.76, 0, 0.24, 1), opacity 1.2s cubic-bezier(0.76, 0, 0.24, 1)';
//     this.pageContainer.style.opacity = '0.1';

//     this.style.transform = 'translateY(0)';

//     document.body.classList.add('page-transition--active');
//   }

//   endPageTransition() {
//     if (!this.isTransitioning) return;
//     this.isTransitioning = false;

//     this.pageContainer.style.transition = '';
//     this.pageContainer.style.transform = '';
//     this.pageContainer.style.opacity = '';

//     this.style.transform = 'translateY(100%)';

//     document.body.classList.remove('page-transition--active');
//   }

//   setupLinks() {
//     document.querySelectorAll('a').forEach(link => {
//       link.addEventListener('click', (e) => {
//         if (link.host === window.location.host && !link.hasAttribute('data-no-transition')) {
//           if (this.isTransitionAllowed(link)) {
//             e.preventDefault();
//             this.startPageTransition();
//             setTimeout(() => {
//               window.location = link.href;
//             }, 1200);
//           }
//         }
//       });
//     });
//   }
// }
// customElements.define('page-transition', PageTransition);
